import { ChangeDetectionStrategy, Component, Input, TrackByFunction } from '@angular/core'
import { ValidationErrors } from '@angular/forms'
import { FormErrorsService } from '../services/form-errors.service'

@Component({
  selector: 'flo-form-errors',
  templateUrl: './form-errors.component.html',
  styleUrls: ['./form-errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormErrorsComponent {
  @Input() errors: ValidationErrors
  @Input() control: string
  @Input() hasIcon = false

  public get errorsList(): ReadonlyArray<ValidationErrors> {
    return Object.keys(this.errors).map(errorName => {
      return this.getMessage(errorName, this.control)
    })
  }

  private getMessage(errorName: string, control: string): ReadonlyArray<string> {
    const messages = this.formErrorsService.errorMessageDict[control]
    return Object.keys(messages)
      .filter(k => k === errorName)
      .map(k => messages[k])
  }

  constructor(private formErrorsService: FormErrorsService) {}

  trackByError: TrackByFunction<any> = (index: number, item: any) => {
    return index
  }
}
